:host {
  --calendar-width: #{$calendarWidth};

  width: 100%;

  &[inline]:not([inline="false"]) {
    width: var(--calendar-width);
  }
}

.stzh-datepicker {
  &__popover {
    --width: auto;
  }

  &__calendar {
    margin-left: auto;
    margin-right: auto;

    &.is-inline {
      width: 100%;
      margin-left: 0px;
      margin-right: 0px;
    }
  }

  &__actions {
    display: flex;
    width: var(--calendar-width);
    margin-left: auto;
    margin-right: auto;

    &.is-inline {
      width: 100%;
      margin-left: 0px;
      margin-right: 0px;
    }

    &:not(:empty) {
      padding-left: space('small');
      padding-right: space('small');
    }
  }

  /* Has action */

  &--has-action &__popover {
    --content-padding: 0 0 #{space('small')} 0;
  }
}
